var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"alert-card-container",style:({ 'background': _vm.data.color })},[_c('div',{staticClass:"card"},[_c('p',[_vm._v(_vm._s(_vm.data.text))]),_c('i',{staticClass:"icon-close",on:{"click":_vm.hideCard}})]),_c('div',{staticClass:"progress-bar"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }